<div class="row">
  <div class="col-12">
    <h4 (click)="collapseInventory.toggle()"
        [attr.aria-expanded]="!isSectionInventoryCollapsed"
        aria-controls="inventory">
      Inventory
    </h4>

    <div #collapseInventory="ngbCollapse" [(ngbCollapse)]="isSectionInventoryCollapsed">
      <div class="card table-result-card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'PV'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Somme convenue
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.agreedAmountForInventory | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'COUT'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Coût
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.adjustedCostBaseForInventory | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'COUT'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Coût
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.adjustedCostBaseForInventory | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'FNACC F'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Revenu (perte) d'entreprise
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'PV'"></app-output-variable>
                  -
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'COUT'"></app-output-variable>
                  =
                  {{ propertyTransferredResults.adjustedCostBaseForInventory | currencyCents | notAvailable }}
                  -
                  {{ propertyTransferredResults.adjustedCostBaseForInventory | currencyCents | notAvailable }}
                  =
                </div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.businessIncome | currencyCents | notAvailable }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>